import React from 'react';
import Container from '../../../containers/master/scholastics/editScholasticContainer';

export default function () {
  return (
    <Container />
  );
}
